import { connect } from "react-redux";
import SurveyStepSecteur from "./SurveyStepSecteur";
//import { surveySelector } from "./../../../../redux/selectors";
import {
	addStepSurvey,
	addElement,
} from "./../../../../redux/actions/surveyActions";
import { getSector } from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {

	return {
		//currentSurvey: surveySelector(state, ownProps),
		surveyProgress: state.survey.surveyManager.surveyProgress,
		currentSectors: state.survey.surveyManager.surveyProgress.sectors || [],
		currentPDCs: state.survey.surveyManager.surveyProgress.pdcs || [],
		sectorList: state.survey.surveyManager.sectorList,
		currentRegionales: state.survey.surveyManager.surveyProgress.regionales || [],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		addElement: data => {
			dispatch(addElement(data));
		},
		getSector: client => {
			dispatch(getSector(client));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(SurveyStepSecteur);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/SurveyStepSecteurContainer.js